// Alias
import Item from '../../private/item';

export default Item;
